import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'

import { types, initialState } from './types'
import { isStaleResponse } from './utils/isStaleResponse'

export const fetchRatingArea = (zipCode, insuranceFiling) => {
  return {
    [RSAA]: {
      endpoint: getApiPath(
        'care',
        `pub/ratingAreaFactors${makeQueryParams({
          zipCode,
          insuranceFiling,
        })}`,
      ),
      headers: {
        'x-api-key': process.env.RATING_AREA_X_API_KEY,
      },
      method: 'GET',
      types: [
        types.FETCH_RATING_AREA_REQUEST,
        types.FETCH_RATING_AREA_SUCCESS,
        types.FETCH_RATING_AREA_ERROR,
      ],
    },
  }
}

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.FETCH_RATING_AREA_REQUEST: {
      return {
        ...state,
        ratingArea: {
          ...state.ratingArea,
          busy: true,
          error: '',
        },
      }
    }

    case types.FETCH_RATING_AREA_SUCCESS: {
      return {
        ...state,
        ratingArea: {
          ...state.ratingArea,
          busy: false,
          entity: payload,
        },
      }
    }
    case types.FETCH_RATING_AREA_ERROR: {
      return {
        ...state,
        ratingArea: {
          ...state.ratingArea,
          busy: false,
          error: payload.response.message,
        },
      }
    }
    // The rating area is returned in the care detail response, use this to update the existing ratingArea
    // This allows the ratingArea to update when the user switches the searchingAs user
    case types.FETCH_CARE_DETAIL_SUCCESS: {
      // This slice reduces over the same shared Care state as `CareDetail`, so it
      // can use the same guard: a detail response the detail slice has already
      // discarded as superseded must not update the rating area either
      // (BASH-219).
      if (isStaleResponse(meta.requestId, state.detail.requestId)) return state

      return {
        ...state,
        ratingArea: {
          ...state.ratingArea,
          entity: {
            ...state.ratingArea.entity,
            // `memberInfo` isn't guaranteed to be on the response and a reducer
            // that throws takes the whole dispatch down with it. Optional
            // chaining only — a response that carries no rating area still
            // clears the previous one, the same as before, because keeping the
            // old member's rating area is what this case exists to prevent.
            ratingArea: payload.memberInfo?.ratingArea,
          },
        },
      }
    }

    default:
      return state
  }
}
